module.exports = __webpack_public_path__ + "static/media/weight_loss_img.dc4bd818.svg";